<template>
  <line
    :x1 = "getXAxisGap"
    :y1 = "yPixel"
    :x2 = "width - getXAxisGap"
    :y2 = "yPixel"
    :style = "axisColor"
  />
  <line
    v-for="(value, index) in xAxisValues"
    :key="index"
    :x1 = "value * getMagScale  + getXAxisGap "
    :y1 = "0"
    :x2 = "value * getMagScale  + getXAxisGap "
    :y2 = "yPixel"
    :style = "axisColor"
    stroke-width="4px"
  />
  <text
    v-for="(value, index) in xAxisValues"
    :key="'label'+ index"
    :x = "value * getMagScale + getXAxisGap "
    :y = "yPixel + 15"
    :style = "pressureStyle"
    text-anchor = middle
    class = "label"
  >
    {{ getConvertedLength(value, index) }}
  </text>
</template>

<script>
import { useInputStore } from '@/store/InputStore';
import { useSegmentStore } from '@/store/SegmentStore';
import * as UnitConversion from '@/services/UnitConversionService';
import { useSettingsStore } from '@/store/SettingsStore';

export default {
  name: 'XAxis',
  data () {
    return {
      height: 0,
      values: []
    };
  },
  computed: {
    axisColor () {
      return 'stroke:rgb(' + useSegmentStore().hexToRgb('#cecece')  + ')';
    },
    pressureStyle () {
      return ' font-size: 11px; font-weight: 600'; // stroke: var(--pressure-color);
    },
    width () {
      return useInputStore().getPressureFlowChartWidth;
    },
    xAxisValues () {
      const inputStore = useInputStore();
      const sprinklerSpacing = inputStore.getSprinklerSpacing;
      let totalVerticalLines = Math.floor((this.width / this.getMagScale) / sprinklerSpacing);
      let values = [];
      let XAxisFrequency = inputStore.getXAxisLabelFrequency; //
      for (let a = 0; a < totalVerticalLines; a++) {
        let value = a * sprinklerSpacing;
        if (a % (XAxisFrequency) === 0) {
          values.push(value);
        }
      }
      this.values = values;
      return values;
    },
    getMagScale () {
      return useSegmentStore().getMagScale;
    },
    getXAxisGap () {
      return useInputStore().getXAxisGap;
    },
    yPixel () {
      const inputStore = useInputStore();
      return inputStore.getPressureFlowChartHeight - inputStore.getSliderGap;
    }
  },
  methods: {
    handleUpdate () {
      let pfc = document.getElementById('pressureFlowChart');
      this.height = pfc ? pfc.getBoundingClientRect().height - useInputStore().sliderGap : 0;
      return this.height;
    },
    getConvertedLength (value, index) {
      let display = UnitConversion.FilterLength(value, useSettingsStore().getLengthUnit).toFixed(2);
      // if there are more than 30 values, this makes it so the numbers don't overlap and crowd together
      if (this.values.length > 30) {
        if (index % 2 === 1) {
          return '';
        } else {
          return display;
        }
      } else {
        return display;
      }
    }
  },
};
</script>

<style scoped>
.label {
  user-select: none;
}
</style>